import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { blurInput } from 'src/app/core/helpers/blur-input';
import { preventNonNumberInput } from 'src/app/core/helpers/check-if-number';
import { TAutoNumericOptions } from 'src/app/core/helpers/create-autonumeric';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { SiteFilterDropdownService } from '../../modules/filters/site-filter-dropdown/site-filter-dropdown-service/site-filter-dropdown.service';

@Component({
  selector: 'pp-filter-field-numbers-input',
  templateUrl: './filter-field-numbers-input.component.html',
  styleUrls: ['./filter-field-numbers-input.component.scss'],
  standalone: false,
})
export class FilterFieldNumbersInputComponent {
  @ViewChild('input') inputElement: ElementRef;
  @Input() ppUnit: string;
  @Input() ppPlaceholder: string;
  @Input() ppValue: number;
  @Input() ppLeftUnit: boolean;
  @Input() ppDecimalPlaces: number;
  @Input() ppShowComma: boolean;
  @Output() ppValueChange = new EventEmitter();

  EIconPath = EIconPath;
  focused = false;

  autonumericOptions: TAutoNumericOptions;

  constructor(private siteFilterDropdownService: SiteFilterDropdownService) {}

  ngOnChanges(): void {
    this.autonumericOptions = {
      formulaMode: true,
      watchExternalChanges: true,
      decimalPlaces: this.ppDecimalPlaces || 0,
      modifyValueOnWheel: false,
      digitGroupSeparator: this.ppShowComma ? ',' : '',
    };
  }

  focusInput(): void {
    this.inputElement.nativeElement.focus();
  }

  blurInput(event: Event): void {
    blurInput(event.target);
  }

  updateField(newValue: string): void {
    this.ppValueChange.emit(parseFloat(newValue));
  }

  onInputFocused(inputIsFocused: boolean): void {
    this.siteFilterDropdownService.setFocused(inputIsFocused);
    this.focused = inputIsFocused;
  }

  preventEvent(event: MouseEvent): void {
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  preventNonNumberInput(event: KeyboardEvent): void {
    preventNonNumberInput(event);
  }
}
